module.exports = __webpack_public_path__ + "assets/ee80149348e829e40df440058caae2ac.ttf";